import React from 'react';

export const UserGrowthCardSvg: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={590}
    height={316}
    viewBox="0 0 590 316"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_597_9739)">
      <circle
        cx={294.922}
        cy={157.921}
        r={185.629}
        stroke="#0A0A0A"
        strokeOpacity={0.16}
        strokeWidth={0.58558}
        strokeLinecap="square"
        strokeDasharray="0.59 2.93"
        className="user-growth-card-svg-ring"
      />
      <circle
        cx={294.921}
        cy={157.922}
        r={247.707}
        stroke="#0A0A0A"
        strokeOpacity={0.16}
        strokeWidth={0.58558}
        strokeLinecap="square"
        strokeDasharray="0.59 2.93"
        className="user-growth-card-svg-ring"
      />
      <circle
        cx={295.075}
        cy={158.075}
        r={138.782}
        stroke="#0A0A0A"
        strokeOpacity={0.16}
        strokeWidth={0.58558}
        strokeLinecap="square"
        strokeDasharray="0.59 2.93"
        className="user-growth-card-svg-ring"
      />
      <path
        d="M295 360.555L295 -44.0807"
        stroke="#0A0A0A"
        strokeOpacity={0.12}
        strokeWidth={0.58558}
        strokeLinecap="square"
        strokeDasharray="0.59 2.93"
        className="user-growth-card-svg-cross"
      />
      <path
        d="M498 158L93.3646 158"
        stroke="#0A0A0A"
        strokeOpacity={0.12}
        strokeWidth={0.58558}
        strokeLinecap="square"
        strokeDasharray="0.59 2.93"
        className="user-growth-card-svg-cross"
      />
      <path
        d="M431.243 188.288L433.689 196.987L424.933 194.756L431.243 188.288Z"
        fill="#D9D9D9"
        className="user-growth-card-svg-graph"
      />
      <path
        d="M165.129 108.645L165.129 99.6093L172.955 104.127L165.129 108.645Z"
        fill="#D9D9D9"
        className="user-growth-card-svg-graph"
      />
      <g
        clipPath="url(#paint0_angular_597_9739_clip_path)"
        data-figma-skip-parse="true"
        className="user-growth-card-svg-circle"
      >
        <g transform="matrix(0 0.041857 -0.0598961 1.14083e-10 294.983 190.327)">
          <foreignObject x="-3227.27"
            y="-3227.27"
            width="6454.53"
            height="6454.53"
          >
            <div
              style={{
                background: 'conic-gradient(from 90deg, rgba(0,0,0,0.2) 0deg, rgba(0,0,0,0) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1,
              }}
            />
          </foreignObject>
        </g>
      </g>

      <path
        d="M396.025 158.012C396.025 213.8 350.8 259.025 295.012 259.025C239.225 259.025 194 213.8 194 158.012C194 102.225 239.225 57 295.012 57C350.8 57 396.025 102.225 396.025 158.012ZM253.314 158.012C253.314 181.042 271.983 199.711 295.012 199.711C318.042 199.711 336.711 181.042 336.711 158.012C336.711 134.983 318.042 116.314 295.012 116.314C271.983 116.314 253.314 134.983 253.314 158.012Z"
        data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.0,"g":0.0,"b":0.0,"a":0.20000000298023224},"position":0.0},{"color":{"r":0.0,"g":0.0,"b":0.0,"a":0.0},"position":1.0}],...}'
      />

      <circle cx={146.779}
        cy={60.7344}
        r={3.22069}
        fill="black"
        className="user-growth-card-svg-graph-black"
      />
      <circle cx={484.951}
        cy={54.587}
        r={4.68464}
        fill="#0A0A0A"
        fillOpacity={0.12}
        opacity={0.5}
        className="user-growth-card-svg-graph"
      />
      <circle cx={500.761}
        cy={265.396}
        r={4.68464}
        fill="#0A0A0A"
        fillOpacity={0.12}
        opacity={0.5}
        className="user-growth-card-svg-graph"
      />

      <mask id="path-13-inside-1_597_9739" fill="white">
        <path d="M336.738 157.869C336.738 180.993 317.993 199.738 294.869 199.738C271.745 199.738 253 180.993 253 157.869C253 134.745 271.745 116 294.869 116C317.993 116 336.738 134.745 336.738 157.869Z" />
      </mask>

      <path
        d="M336.738 157.869C336.738 180.993 317.993 199.738 294.869 199.738C271.745 199.738 253 180.993 253 157.869C253 134.745 271.745 116 294.869 116C317.993 116 336.738 134.745 336.738 157.869Z"
        fill="white"
      />

      <g clipPath="url(#paint1_angular_597_9739_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-13-inside-1_597_9739)"
        className="user-growth-card-svg-circle"
      >
        <g transform="matrix(-0.000228795 0.027455 -0.027455 -0.000228795 295.098 159.699)">
          <foreignObject x="-1647.2"
            y="-1647.2"
            width="3294.41"
            height="3294.41"
          >
            <div
              style={{
                background: 'conic-gradient(from 90deg, rgba(0,0,0,1) 0deg, rgba(0,0,0,0) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1,
              }}
            />
          </foreignObject>
        </g>
      </g>

      <path
        d="M336.738 157.869H335.567C335.567 180.346 317.346 198.567 294.869 198.567V199.738V200.909C318.639 200.909 337.909 181.639 337.909 157.869H336.738ZM294.869 199.738V198.567C272.392 198.567 254.171 180.346 254.171 157.869H253H251.829C251.829 181.639 271.099 200.909 294.869 200.909V199.738ZM253 157.869H254.171C254.171 135.392 272.392 117.171 294.869 117.171V116V114.829C271.099 114.829 251.829 134.099 251.829 157.869H253ZM294.869 116V117.171C317.346 117.171 335.567 135.392 335.567 157.869H336.738H337.909C337.909 134.099 318.639 114.829 294.869 114.829V116Z"
        data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0,"g":0,"b":0,"a":1},"position":0},{"color":{"r":0,"g":0,"b":0,"a":0},"position":1}],...}'
        mask="url(#path-13-inside-1_597_9739)"
      />

      <circle cx={479.27}
        cy={135.27}
        r={5.27022}
        fill="black"
        className="user-growth-card-svg-graph-black"
      />
      <circle cx={130.09}
        cy={282.377}
        r={3.51348}
        fill="#0A0A0A"
        fillOpacity={0.12}
        className="user-growth-card-svg-graph"
      />
      <circle cx={221.099}
        cy={275.099}
        r={4.09906}
        fill="black"
        className="user-growth-card-svg-graph-black"
      />
      <circle cx={94.6846}
        cy={79.6846}
        r={4.68464}
        fill="#0A0A0A"
        fillOpacity={0.12}
        opacity={0.5}
        className="user-growth-card-svg-graph"
      />
      <g className="user-growth-card-svg-icon icon-one">
        <rect x={378.293}
          y={44.2928}
          width={20.4953}
          height={20.4953}
          rx={10.2476}
          stroke="black"
          strokeOpacity={0.96}
          strokeWidth={0.58558}
        />
        <g clipPath="url(#clip1_597_9739)">
          <circle cx={388.54}
            cy={54.5404}
            r={10.5404}
            fill="black"
          />
          <circle cx={388.54}
            cy={52.783}
            r={3.51348}
            fill="white"
          />
          <path d="M383.856 61.5674C383.856 58.9802 385.953 56.8828 388.54 56.8828C391.128 56.8828 393.225 58.9802 393.225 61.5674V69.7656H383.856V61.5674Z" fill="white" />
        </g>
      </g>
      <g className="user-growth-card-svg-icon icon-two">
        <g clipPath="url(#clip2_597_9739)">
          <circle cx={390.054}
            cy={259.054}
            r={14.0539}
            fill="black"
          />
          <circle cx={390.054}
            cy={256.712}
            r={4.68464}
            fill="white"
          />
          <path d="M383.808 268.424C383.808 264.974 386.604 262.178 390.054 262.178C393.503 262.178 396.3 264.974 396.3 268.424V279.355H383.808V268.424Z" fill="white" />
        </g>
        <rect x={376.39}
          y={245.39}
          width={27.327}
          height={27.327}
          rx={13.6635}
          stroke="black"
          strokeOpacity={0.96}
          strokeWidth={0.780773}
        />
      </g>
      <g className="user-growth-card-svg-icon icon-three">
        <g clipPath="url(#clip3_597_9739)" >
          <circle cx={165.369}
            cy={205.369}
            r={9.36927}
            fill="black"
          />
          <circle cx={165.369}
            cy={203.807}
            r={3.12309}
            fill="white"
          />
          <path d="M161.205 211.615C161.205 209.315 163.069 207.451 165.369 207.451C167.669 207.451 169.533 209.315 169.533 211.615V218.902H161.205V211.615Z" fill="white" />
        </g>
        <rect x={156.26}
          y={196.26}
          width={18.218}
          height={18.218}
          rx={9.10901}
          stroke="black"
          strokeOpacity={0.96}
          strokeWidth={0.520515}
        />
      </g>

    </g>

    <defs>
      <clipPath id="paint0_angular_597_9739_clip_path">
        <path d="M396.025 158.012C396.025 213.8 350.8 259.025 295.012 259.025C239.225 259.025 194 213.8 194 158.012C194 102.225 239.225 57 295.012 57C350.8 57 396.025 102.225 396.025 158.012ZM253.314 158.012C253.314 181.042 271.983 199.711 295.012 199.711C318.042 199.711 336.711 181.042 336.711 158.012C336.711 134.983 318.042 116.314 295.012 116.314C271.983 116.314 253.314 134.983 253.314 158.012Z" />
      </clipPath>
      <clipPath id="paint1_angular_597_9739_clip_path">
        <path d="M336.738 157.869H335.567C335.567 180.346 317.346 198.567 294.869 198.567V199.738V200.909C318.639 200.909 337.909 181.639 337.909 157.869H336.738ZM294.869 199.738V198.567C272.392 198.567 254.171 180.346 254.171 157.869H253H251.829C251.829 181.639 271.099 200.909 294.869 200.909V199.738ZM253 157.869H254.171C254.171 135.392 272.392 117.171 294.869 117.171V116V114.829C271.099 114.829 251.829 134.099 251.829 157.869H253ZM294.869 116V117.171C317.346 117.171 335.567 135.392 335.567 157.869H336.738H337.909C337.909 134.099 318.639 114.829 294.869 114.829V116Z" />
      </clipPath>
      <clipPath id="clip0_597_9739">
        <rect width={590}
          height={316}
          rx={6.38814}
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_597_9739">
        <rect x={378}
          y={44}
          width={21.0809}
          height={21.0809}
          rx={10.5404}
          fill="white"
        />
      </clipPath>
      <clipPath id="clip2_597_9739">
        <rect x={376}
          y={245}
          width={28.1078}
          height={28.1078}
          rx={14.0539}
          fill="white"
        />
      </clipPath>
      <clipPath id="clip3_597_9739">
        <rect x={156}
          y={196}
          width={18.7385}
          height={18.7385}
          rx={9.36927}
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export default UserGrowthCardSvg;